import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Expands status values to include both lowercase and uppercase versions
 * This ensures API queries match regardless of case in the database
 * @param statuses - Array of status strings or undefined
 * @returns Array with both lowercase and uppercase versions, or undefined
 */
export function expandStatusCase(statuses?: string[]): string[] | undefined {
  if (!statuses || statuses.length === 0) return undefined;

  const expanded = new Set<string>();
  statuses.forEach(status => {
    expanded.add(status.toUpperCase());
  });

  return Array.from(expanded);
}
